/**
 * Auth constants for the web app (hardcoded).
 * Keep GOOGLE_CLIENT_ID and DISALLOWED_EMAIL_REGEXES in sync with backend/auth_constants.js.
 */
export const GOOGLE_CLIENT_ID =
    '724405183597-qqmqnhdi2k7qd5m0u2de1b069etv333j.apps.googleusercontent.com';

export const PASSWORD_MIN_LENGTH = 8;

/**
 * Throwaway / disposable email patterns. Keep in sync with backend/auth_constants.js.
 * Matched against the full normalized (trim + lowercase) email.
 */
export const DISALLOWED_EMAIL_REGEXES = [
    /@(?:proton\.(?:me|mail)|pm\.me)$/i,
    /@(?:mailinator|protonmail|guerrillamail|tempmail|10minutemail|yopmail|trashmail)\./i,
];

export const DISALLOWED_EMAIL_MESSAGE = 'You must use an email address associated with your law firm to register';

/** @param {string} email */
export function isDisallowedEmail(email) {
    const normalized = (email == null || typeof email !== 'string') ? '' : email.trim().toLowerCase();
    if (!normalized) return false;
    return DISALLOWED_EMAIL_REGEXES.some((re) => re.test(normalized));
}

/** Options for client-readable cookies (terms flag, display profile). */
export function clientCookieOptions() {
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    return {
        path: '/',
        secure,
        sameSite: 'strict',
    };
}
